import * as $ from 'jquery';

class AJAX {
    private BASE_URL = "https://api.supportbench.net";
    private CHAT_URL = "https://kuai.azurewebsites.net/api/prompt_route";
    private AI_SEARCH_URL = "https://api.supportbench.net/ai/search";

    public sendAjaxRequest(_type: string, _url: string, _params: string, _callback: (res: any) => void): void {
        $.ajax({
            type: _type,
            url: `${this.BASE_URL}${_url}`,
            data: _params,
            crossDomain: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        }).done(res => {
            _callback(res);
        }).fail(jqXHR => {
            if (jqXHR.status !== 200) {
                console.error(jqXHR);
            }
        });
    }

    public sendChatAjaxRequest(_type: string, _url: string, _params: string, _callback: (res: any) => void): void {
        $.ajax({
            type: _type,
            url: `${this.CHAT_URL}${_url}`,
            data: _params,
            crossDomain: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        }).done(res => {
            _callback(res);
        }).fail(jqXHR => {
            if (jqXHR.status !== 200) {
                console.error(jqXHR);
            }
        });
    }

    public sendAjaxRequestFile(_type: string, _url: string, _params: FormData, _callback: (res: any) => void): void {
        $.ajax({
            type: _type,
            url: `${this.BASE_URL}${_url}`,
            data: _params,
            crossDomain: true,
            processData: false,
            contentType: false
        }).done(res => {
            _callback(res);
        }).fail(jqXHR => {
            if (jqXHR.status !== 200) {
                console.error(jqXHR);
            }
        });
    }

    public sendAISearchRequest(_type: string, _url: string, _params: string, _callback: (res: any) => void): void {
        $.ajax({
            type: _type,
            url: `${this.AI_SEARCH_URL}${_url}`,
            data: _params,
            crossDomain: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        }).done(res => {
            _callback(res);
        }).fail(jqXHR => {
            if (jqXHR.status !== 200) {
                console.error(jqXHR);
            }
        });
    }
}

export const __ajax = new AJAX();
